module.exports = __webpack_public_path__ + "media/LMB_Garden1_Music.45d5a7ab.mp3";